var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStructure = function SvgStructure(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3891 1.7987H0.610889C0.273678 1.7987 0 1.39579 0 0.899348C0 0.402908 0.273678 0 0.610889 0H15.3891C15.7263 0 16 0.402908 16 0.899348C16 1.39579 15.7263 1.7987 15.3891 1.7987Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3682 3.33333H0.631845C0.283067 3.33333 0 3.67455 0 4.09498V13.2383C0 13.6588 0.283067 14 0.631845 14H15.3682C15.7169 14 16 13.6588 16 13.2383V4.09498C16 3.67455 15.7169 3.33333 15.3682 3.33333ZM6.57119 12.4767L10.3799 4.85664H13.8926L10.0838 12.4767H6.57119ZM2.00842 12.4767L5.81719 4.85664H9.39638L5.58762 12.4767H2.00842ZM4.83361 4.85664L1.26369 11.9984V4.85664H4.83361ZM11.0674 12.4767L14.7363 5.13642V12.4767H11.0674Z",
    fill: "#1D1D1B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStructure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Structure.79ba3ff4581a80d63727387125b09835.svg";